<script setup>
import {computed} from 'vue';

const props = defineProps({
  application: {
    type: Object,
    required: true,
  },
  // When true, shows a "Cancel" action that emits `cancel` with the application.
  cancellable: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['cancel']);

const {uploadFilenameToUrl} = useCrudConverters();

const clubImageUrl = computed(() => {
  const imageFileName = props.application.club?.imageFileName;
  if (!imageFileName) return null;
  return uploadFilenameToUrl(imageFileName, 'medium');
});
</script>

<template>
  <v-list-item class="pa-4">
    <template #prepend>
      <v-avatar v-if="clubImageUrl" size="48">
        <v-img :src="clubImageUrl" cover />
      </v-avatar>
      <v-avatar v-else size="48" style="background: rgb(var(--v-theme-brandTint)); color: rgb(var(--v-theme-primary));">
        <v-icon>mdi-account-group</v-icon>
      </v-avatar>
    </template>
    <v-list-item-title class="font-weight-bold">
      <router-link class="text-primary link-text" :to="{ name: 'ClubDetail', params: { clubId: application.club.id } }">
        {{ application.club.name }}
      </router-link>
      <template v-if="application.ladder">
        -
        <router-link class="text-primary link-text" :to="{ name: 'LadderDetail', params: { ladderId: application.ladder.id } }">
          {{ application.ladder.name }}
        </router-link>
      </template>
      <template v-if="application.leagueCycle">
        -
        <router-link class="link-text" :to="{ name: 'LeagueDetail', params: { leagueId: application.leagueCycle.leagueId, cycleId: application.leagueCycle.id } }">
          {{ application.leagueCycle.name }}
        </router-link>
      </template>
    </v-list-item-title>
    <v-list-item-subtitle v-if="application.message" class="mt-1">
      "{{ application.message }}"
    </v-list-item-subtitle>
    <template #append>
      <div class="aauc-append">
        <span class="tl-chip tl-chip--warn">
          Pending
        </span>
        <button
            v-if="cancellable"
            type="button"
            class="aauc-cancel"
            @click="$emit('cancel', application)"
        >Cancel request</button>
      </div>
    </template>
  </v-list-item>
</template>

<style scoped>
.tl-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
}

.aauc-append {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.aauc-cancel {
  font-size: 11.5px;
  font-weight: 600;
  color: rgb(var(--v-theme-textSubtle));

  &:hover {
    color: rgb(var(--v-theme-error));
    text-decoration: underline;
  }
}
</style>
